import { FC } from "react";
import { Card, List, Image, Rating } from "semantic-ui-react";
import { ServiceDetailsCardProps } from "./types";

const MarketplaceAppDetailServiceDetailsCard: FC<ServiceDetailsCardProps> = ({
  details,
}) => {
  return (
    <div className="marketplace-app-detail--additional">
      <Card fluid className="margin-bottom-00">
        {details.title && (
          <Card.Header className="text-center">
            {details.title || "Service Details"}
          </Card.Header>
        )}
        {details.image && <Image src={details.image} wrapped ui={false} />}
        <Card.Content>
          {details.meta && <Card.Meta>{details.meta}</Card.Meta>}
          <Card.Description>
            {details.attributes && (
              <List divided verticalAlign="middle">
                {details.attributes.map((attr, idx) => (
                  <List.Item key={idx}>
                    <List.Content floated="right">
                      {attr.url ? (
                        <a
                          href={attr.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {attr.value}
                        </a>
                      ) : attr.label === "Rating" ? (
                        <Rating
                          icon="star"
                          defaultRating={parseFloat(attr.value)}
                          maxRating={5}
                          disabled
                        />
                      ) : (
                        attr.value
                      )}
                    </List.Content>
                    <List.Content>{attr.label}</List.Content>
                  </List.Item>
                ))}
              </List>
            )}
          </Card.Description>
        </Card.Content>
      </Card>
      {details.relatedLinks && details.relatedLinks.length > 0 && (
        <Card fluid className="related-links margin-top-00">
          <Card.Header className="text-center">Related Links</Card.Header>
          <Card.Content extra>
            <ul>
              {details.relatedLinks.map((link, idx) => (
                <li key={idx}>
                  <a href={link.url} target="_blank" rel="noopener noreferrer">
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          </Card.Content>
        </Card>
      )}
    </div>
  );
};
export default MarketplaceAppDetailServiceDetailsCard;
